import { defineAsyncComponent } from 'vue';
import { MCP_SERVER_TABS } from './components/McpServerSettingsPage/constants';

export const mcpServerSettingsRoutes = [
	{
		path: '/settings/integrations/mcpServer/logs',
		name: MCP_SERVER_TABS.LOGS,
		component: () => import('./components/McpServerSettingsPage'),
	},
	{
		path: '/settings/integrations/mcpServer',
		name: MCP_SERVER_TABS.GENERAL_SETTINGS,
		component: () => import('./components/McpServerSettingsPage'),
	},
];

export const mcpServerSettingsFrontends = {
	McpServerSettingsPage: defineAsyncComponent(
		() => import('./components/McpServerSettingsPage')
	),
};

export * from './components/McpServerSettingsPage/types';
export * from './components/McpServerSettingsPage/constants';
